import Vue from 'vue'
import methods from './methods.js'
import data from './data'
import livecycle from './lifecycle'
Vue.mixin({
	data() {
		return data
	},
	methods:{
		...methods
	},
	...livecycle
})
